// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_19-2";
export var blackBorderOnHover = "_19-7";
export var cell = "_19-6";
export var cellContainer = "_19-3";
export var checked = "_19-8";
export var disabled = "_19-5";
export var featuredIconCellContainer = "_19-9";
export var featuredIconTextContainer = "_19-b";
export var featuredIconWrapper = "_19-a";
export var noBorder = "_19-c";
export var orangeSelectedRow = "_3w-3";
export var overflowableText = "_19-0";
export var overflowableTextContainer = "_19-1";
export var row = "_1a-0";
export var rowCheckboxCell = "_19-4";
export var selectableTable = "_3w-2";